import { createContext, useContext } from "react";
import { AreaStore } from "./store/store";

export const ProductAreaContext = createContext<AreaStore>(null!);

export const useProductArea = () => useContext(ProductAreaContext);